import {
  type ProductizedServicePriceInterval,
  type ProductizedServicePriceType,
} from '#app/__generated__/api.js';
import { Text } from '#app/components/Primitives/Text.js';
import { PRICE_TYPE_LABELS } from '#app/features/productizedServiceLegacy/constants.js';
import {
  constructPricingLabel,
  constructPricingTimelineLabel,
} from '#app/features/productizedServiceLegacy/utilities/index.js';
import { css, styled } from 'styled-components';

const Pricing = styled.div`
  flex: 1;
`;

const StartingAtText = styled(Text).attrs({
  as: 'div',
  textStyle: 'overline',
})`
  ${({ theme }) => css`
    color: ${theme.colorsV2.gray60};
  `}
`;
const TimelineLabelText = styled(Text).attrs({
  as: 'div',
  textStyle: 'bodySmall',
})`
  ${({ theme }) => css`
    color: ${theme.colorsV2.gray70};
    margin-top: 4px;
  `}
`;

type ProductizedServiceCardPricingProps = {
  readonly price: {
    readonly amount: null | number;
    readonly interval: null | ProductizedServicePriceInterval;
    readonly timeline: null | string;
    readonly type: ProductizedServicePriceType;
  };
};

export const ProductizedServiceCardPricing = ({
  price,
}: ProductizedServiceCardPricingProps) => {
  const isContactForPricing = price.type === 'CONTACT_FOR_PRICING';

  const pricingLabel = isContactForPricing
    ? PRICE_TYPE_LABELS.CONTACT_FOR_PRICING
    : constructPricingLabel(price.amount, price.interval);

  const timelineLabel = constructPricingTimelineLabel(
    price.type,
    price.timeline,
  );

  return (
    <Pricing>
      {!isContactForPricing && price.amount ? (
        <StartingAtText>Starting At</StartingAtText>
      ) : null}

      <Text
        as="div"
        textStyle="fifthLevelHeadline"
      >
        {pricingLabel}
      </Text>

      {price.amount ? (
        <TimelineLabelText>{timelineLabel}</TimelineLabelText>
      ) : null}
    </Pricing>
  );
};
